export const navbar = [
  {
    active: "home",
    to: "home",
    name: "Home",
  },
  // {
  //   active: "about",
  //   to: "about",
  //   name: "About",
  // },
  {
    active: "work",
    to: "work",
    name: "Work",
  },
  // {
  //   active: "testimonial",
  //   to: "testimonial",
  //   name: "Testimonial",
  // },
  {
    active: "skill",
    to: "skill",
    name: "Skills",
  },
  {
    active: "contact",
    to: "contactForm",
    name: "Contact",
  },
];
